import axios from 'axios';

import { ResponseObj } from '../../../back/src/types';
import { TokenSenha } from '../../../back/src/entity/TokenSenha';

const tokenSenha = async (token: string): Promise<ResponseObj<TokenSenha>> => {
  const res = await axios.get<ResponseObj<TokenSenha>>(`tokens_senha/${token}`);
  return res.data;
};

export default {
  tokenSenha,
};
